import { gql } from "@apollo/client";

export const SEND_MARKETPLACE_QUOTE = gql`
  mutation SendMarketplaceQuote(
    $sendMarketplaceQuoteInput: SendMarketplaceQuoteInput!
  ) {
    sendMarketplaceQuote(
      sendMarketplaceQuoteInput: $sendMarketplaceQuoteInput
    ) {
      success
      message
    }
  }
`;

export default {
  SEND_MARKETPLACE_QUOTE
};
